import { LoaderFunctionArgs, redirect } from "react-router";

export default async function bookmarksLoader(args: LoaderFunctionArgs) {
  const {pageTab} = args.params;
  if (!pageTab) return redirect("/marketplace/bookmarks/individual");
  return args.params;
}
